var InjectSituationType = /* @__PURE__ */ ((InjectSituationType2) => {
  InjectSituationType2["HOST_SET"] = "SIMPLE_WEB_COMPONENT://HOSTSET";
  InjectSituationType2["APP_HOST"] = "SIMPLE_WEB_COMPONENT://APPHOST";
  InjectSituationType2["APP_HOSTS"] = "SIMPLE_WEB_COMPONENT://APPHOSTS";
  InjectSituationType2["HOST"] = "SIMPLE_WEB_COMPONENT://HOST";
  InjectSituationType2["PARENT_HOST"] = "SIMPLE_WEB_COMPONENT://PARENTHOST";
  InjectSituationType2["HOSTS"] = "SIMPLE_WEB_COMPONENT://HOSTS";
  InjectSituationType2["FIRST_HOST"] = "SIMPLE_WEB_COMPONENT://FIRSTHOST";
  InjectSituationType2["LAST_HOST"] = "SIMPLE_WEB_COMPONENT://LASTHOST";
  InjectSituationType2["FIRST_APP_HOST"] = "SIMPLE_WEB_COMPONENT://FIRSTAPPHOST";
  InjectSituationType2["LAST_APP_HOST"] = "SIMPLE_WEB_COMPONENT://LASTAPPHOST";
  return InjectSituationType2;
})(InjectSituationType || {});
const isSelfObserverMeta = (m) => !m.options?.delegate && (m.selector === "$this" || m.selector === "");
const inObserverScope = (m, scope) => !scope || scope === "self" === isSelfObserverMeta(m);
export {
  InjectSituationType,
  inObserverScope,
  isSelfObserverMeta
};
//# sourceMappingURL=index.js.map
